<template>
  <tr :class="{'red lighten-2': !item.active}">
    <td>{{ item.sku }}</td>
    <td>{{ item.label }}</td>
    <td>{{ item.capacity }}</td>
    <td :class="item.remain === 0 ? 'red--text font-weight-bold' : ''">{{ item.remain }}</td>
    <td>{{ item.fill }}</td>
    <td>{{ item.name }}</td>
    <td>{{ item.price }}</td>
    <td>{{ item.expired_at }}</td>
  </tr>
</template>

<script>
  export default {
    props: {
      item: Object,
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/Rental/Locations/Coil.vue